import { APISlideAttributes } from '@ardoq/api-types';
import { crudApi } from './api';

export const slideApi = {
  ...crudApi<APISlideAttributes>('slide'),
};
